import { useState } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { APP_PATHS } from "../../../../../constants/paths";
import { SKUS_QUERY_STRING } from "../../../../../constants/skus";
// import dropdownArrow from "../../../../../assets/icons/dropdown_arrow.svg";
import searchIcon from "../../../../../assets/icons/search.svg";
import classes from "./Search.module.css";

const Search = () => {
  const { pathname: currentPath } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState(
    currentPath === APP_PATHS.SKUS.url &&
      searchParams.get(SKUS_QUERY_STRING.COMMERCIAL_NAME)?.trim() !== ""
      ? searchParams.get(SKUS_QUERY_STRING.COMMERCIAL_NAME) || ""
      : ""
  );

  const searchTextChangedHandler = (e) => {
    setSearchText(e.target.value);
  };

  const searchHandler = () => {
    if (searchText.trim() === "" && currentPath === APP_PATHS.SKUS.url) {
      if (searchParams.has(SKUS_QUERY_STRING.COMMERCIAL_NAME)) {
        searchParams.delete(SKUS_QUERY_STRING.COMMERCIAL_NAME);
        setSearchParams(searchParams);
      }
    } else if (searchText.trim() !== "") {
      if (currentPath === APP_PATHS.SKUS.url) {
        searchParams.set(SKUS_QUERY_STRING.COMMERCIAL_NAME, searchText);
        setSearchParams(searchParams);
      } else {
        navigate(
          `${APP_PATHS.SKUS.url}?${SKUS_QUERY_STRING.COMMERCIAL_NAME}=${searchText}`
        );
      }
    }
  };

  const searchInputKeyPressedHandler = (event) => {
    const { key } = event;
    if (key === "Enter") {
      searchHandler();
    }
  };

  return (
    <div className={classNames("flex items-center", classes.search)}>
      {/* <div className={classNames("flex items-center", classes.search__filter)}>
        <span className={classes["search__filter-text"]}>كل الفئات</span>
        <img src={dropdownArrow} alt="dropdown" />
      </div>
      <span className={classes.search__line} /> */}
      <div
        className={classNames(
          "grow flex gap-1",
          classes["search__input-wrapper"]
        )}
      >
        <input
          className={classNames("grow", classes["search__input"])}
          placeholder="بحث"
          value={searchText}
          onChange={searchTextChangedHandler}
          onKeyDown={searchInputKeyPressedHandler}
        />
        <img
          src={searchIcon}
          alt="search"
          role="button"
          className="pointer"
          onClick={searchHandler}
        />
      </div>
    </div>
  );
};

export default Search;
